package com.nonopn.skydome.common.app.pages.activity

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

import com.nonopn.skydome.common.app.api.impl.ApiInterface
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.main.MainScreen

// ──────────────────────────────────────────────
// My map — full-screen interactive OSM map.
// Replaces the former 4-tab screen (Impacts / Map / Projects / Search).
// Delegates entirely to MainScreen which owns zoom controls, date selector,
// all-day toggle, 2h-slot picker, impact counter, probe popup and probe selector.
// ──────────────────────────────────────────────

@Composable
fun ActivityScreen(modifier: Modifier = Modifier, api: ApiInterface) {
    val appModel: AppModel = LocalApp.current

    MainScreen(
        modifier = modifier,
        appModel = appModel,
        currentInterface = api,
        isAdmin = false
    )
}
